document.addEventListener('DOMContentLoaded', () => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const megaMenus = document.querySelectorAll('.header__inline-menu details.mega-menu');

  megaMenus.forEach((details) => {
    const summary = details.querySelector('summary');

    details.addEventListener('mouseenter', () => {
      if (!desktopQuery.matches) return;
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      if (!desktopQuery.matches) return;
      details.removeAttribute('open');
    });

    details.addEventListener('focusin', () => {
      if (!desktopQuery.matches) return;
      details.setAttribute('open', '');
    });

    details.addEventListener('focusout', (event) => {
      if (!desktopQuery.matches) return;
      if (!details.contains(event.relatedTarget)) {
        details.removeAttribute('open');
      }
    });

    if (summary) {
      summary.addEventListener('click', (event) => {
        if (!desktopQuery.matches) return;
        event.preventDefault();
      });
    }
  });
});